<h3 mat-dialog-title class="title">{{ data.title }}</h3>

<mat-dialog-content>
    <txp-item-list class="item-list"
                [header]="data.itemsListTitle"
                [enableSelection]="true"
                [enableMultiSelect]="data.multiItemSelection"
                [selectAllItemsByDefault]="true"
                [data]="data.itemsList"
                (emitSelection)="onSelected($event)"
                listKey="name">
    </txp-item-list>
</mat-dialog-content>

<mat-dialog-actions>
    <txp-button
        (click)="handleCancel()"
        data-qa-label="CancelButton"
        [style]="buttonStyle.SECONDARY">
        {{ data.cancelText }}
    </txp-button>
    <txp-button
        data-qa-label="ContinueButton"
        [style]="buttonStyle.PRIMARY"
        (click)="handleContinue()"
        [disabled]="disableContinueBtn" >
        {{ data.confirmText }}
    </txp-button>
</mat-dialog-actions>
